'use strict';

require('suppressed-error/auto');

require('./shim')();
